import { ControlValidityColorCriterion } from "../model";
import { evaluateCriterion } from "../../utils";

export const defaultControlValidityColorCriteria: ControlValidityColorCriterion[] = [
  { predicate: { operator: "<", rightOperand: 600 }, value: "#f44336" },
  { predicate: { operator: "<", rightOperand: 1800 }, value: "#ff9800" },
  { predicate: { operator: ">=", rightOperand: 1800 }, value: "#4caf50" }
];

/**
 * Get a color to highlight the control validity status.
 *
 * @param endDatetime - Control end datetime.
 * @param controlValidityColorCriteria - The control validity color criteria,
 * you can provide as many criterion as you want. (default to `[]`)
 * See the `ControlValidityColorCriterion` type for further explanations.
 * @returns A color or nothing if no endDatetime provided are no match found.
 */
export function getControlValidityColor(
  endDatetime?: Date,
  controlValidityColorCriteria: ControlValidityColorCriterion[] = []
): string | undefined {
  if (endDatetime === undefined) return;

  const now = Date.now();

  for (let i = 0; i < controlValidityColorCriteria.length; i++) {
    const {
      predicate,
      value
    }: ControlValidityColorCriterion = controlValidityColorCriteria[i];
    const differenceInMs = endDatetime.getTime() - now;
    const durationInMs = predicate.rightOperand * 1000;
    let controlValidityColor: string | undefined;

    try {
      controlValidityColor = evaluateCriterion<string, number>(differenceInMs, {
        predicate: { ...predicate, rightOperand: durationInMs },
        value
      });
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
    }

    if (controlValidityColor !== undefined) return controlValidityColor;
  }

  return;
}

export default getControlValidityColor;
